module.exports = __webpack_public_path__ + "img/underline.a7223369.svg";